import { Component, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-net-profit-stats',
  templateUrl: './net-profit-stats.component.html',
  styleUrls: ['./net-profit-stats.component.scss']
})
export class NetProfitStatsComponent implements OnDestroy {
  params:any;
  data;
  loader:boolean=false;
  analyticsBreakdownData:any[]=[];
  totalProfit;
  private destroy$ = new Subject<void>();

  constructor(
    private reportsService:ReportsService,
    private snackBar :MatSnackBar) {}
  
  agInit(param:any){
    this.params = param;
  }

  openDialog(){
    if(this.params.type){
      this.openBrekdown();
    }else{
      this.data = this.params?.data;
    }
  }

  openBrekdown() {
    this.loader=true;
    let payload: any;
    if (this.params?.page == 'profitByDate') {
      payload = {
        dateFrom: this.params.data.Date,
        dateTo: this.params.data.Date,
        account: this.params.data.Account
      }
    } else {
      payload = {
        dateFrom: this.params.dateFilter.from,
        dateTo: this.params.dateFilter.to,
        accountSkuId: this.params.data.AccountSkuId
      }
    }
    payload.type = this.params?.type;
    this.reportsService.AnalyticsSectionBreakdown(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        if (res) {
          this.analyticsBreakdownData = res;
          this.totalProfit = this.analyticsBreakdownData.reduce((acc, curr) => acc + curr.amount, 0);
          this.loader=false;
        }
      },  
     error: (error) => {
      this.loader=false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: error.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
    }
   });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
